import { useEffect, useState } from "react";

const calc = (target) => {
  const diff = Math.max(0, target.getTime() - Date.now());
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s };
};

const pad = (n) => String(n).padStart(2, "0");

export const CountdownTimer = ({ target, size = "lg", testid = "countdown" }) => {
  const [t, setT] = useState(() => calc(target));

  useEffect(() => {
    const i = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(i);
  }, [target]);

  const sizes = {
    lg: { num: "text-5xl md:text-7xl", label: "text-[10px] md:text-xs", gap: "gap-6 md:gap-12" },
    md: { num: "text-4xl md:text-5xl", label: "text-[10px] md:text-xs", gap: "gap-5 md:gap-10" },
  };
  const s = sizes[size] || sizes.lg;

  const units = [
    { v: pad(t.d), l: "Days" },
    { v: pad(t.h), l: "Hours" },
    { v: pad(t.m), l: "Minutes" },
    { v: pad(t.s), l: "Seconds" },
  ];

  return (
    <div className={`flex ${s.gap} justify-center items-start`} data-testid={testid}>
      {units.map((u, i) => (
        <div key={u.l} className="flex items-start">
          <div className="text-center" data-testid={`${testid}-${u.l.toLowerCase()}`}>
            <div className={`font-serif font-light text-[#C9587E] ${s.num} leading-none tabular-nums`}>
              {u.v}
            </div>
            <div className={`font-body uppercase tracking-[0.25em] text-[#97808A] mt-3 ${s.label}`}>
              {u.l}
            </div>
          </div>
          {i < units.length - 1 && (
            <div className={`font-serif font-light text-[#C9587E]/30 ${s.num} leading-none ml-4 md:ml-8 hidden sm:block`}>
              :
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
